import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { IMAGE_BY_TYPE } from 'components/appPayment/AppPayment.types';
import {
  CardWLGroupedItemContainer,
  CardWLGroupedItemContent,
  CardWLGroupedItemTitle,
  CardWLGroupedItemDescription,
  CardWLGroupedItemPaymentIcon,
} from './CardWLGroupedItem.styles';
import { CARD_TYPE_ID, C2P_TYPE_ID, GROUPED_CARD_TYPE } from '../CardWLGrouped.types';

export interface IGroupedItem {
  methodId: string;
  isActive: (methodId: string) => boolean;
  setActiveCardMethodTypeId: (methodId) => void;
}

const supportedMtehods = [CARD_TYPE_ID, C2P_TYPE_ID];

export const CardWLGroupedItem = memo((props: IGroupedItem) => {
  const { methodId, isActive, setActiveCardMethodTypeId } = props;

  if (!supportedMtehods.includes(methodId)) {
    throw new Error(`Not supported payment method: ${methodId}`);
  }

  function getType(id: string): string | undefined {
    if (id === CARD_TYPE_ID) return GROUPED_CARD_TYPE.CARD;
    if (id === C2P_TYPE_ID) return GROUPED_CARD_TYPE.CLICK_TO_PAY;
    return undefined;
  }

  function getImage(id: string | number) {
    if (id === C2P_TYPE_ID) return IMAGE_BY_TYPE.CLICK_TO_PAY;
    return IMAGE_BY_TYPE.CARD;
  }

  function handleClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>, id: string): void {
    e.preventDefault();
    setActiveCardMethodTypeId(id);
  }

  return (
    <CardWLGroupedItemContainer
      onClick={e => handleClick(e, methodId)}
      isSelected={isActive(methodId)}
      hasForm={methodId === CARD_TYPE_ID}
    >
      <CardWLGroupedItemContent>
        <CardWLGroupedItemTitle className={`card-wl-grouped-payment-title__${methodId}`}>
          <FormattedMessage id={`paymentMethod.grouped.title.${getType(methodId)}`} />
        </CardWLGroupedItemTitle>
        <CardWLGroupedItemDescription className={`card-wl-grouped-payment-description__${methodId}`}>
          <FormattedMessage
            id={`paymentMethod.grouped.description.${getType(methodId)}`}
            values={{ i: chunk => <strong> {chunk}</strong> }}
          />
        </CardWLGroupedItemDescription>
      </CardWLGroupedItemContent>
      <CardWLGroupedItemPaymentIcon className={`card-wl-grouped-payment-icon__${methodId}`}>
        <img src={getImage(methodId)} alt={getType(methodId)} />
      </CardWLGroupedItemPaymentIcon>
    </CardWLGroupedItemContainer>
  );
});
